import { NativeApp, NativeAppType, ScanBarcodeResult } from "./";

// Tell Typescript about the androidApp property the Android app puts on window
declare global {
  interface Window {
    androidApp?: NativeAndroid;
  }
}

const nativeApp = window.androidApp;

/** Defines the methods that are available on the Android Native App */
export interface NativeAndroid {
  scanBarcode(): void;
  navigateToEditServer(): void;
}

/** Defines the methods that are available for the Android Native App to call */
export interface AndroidActions {
  sendBarcodeResult(result: ScanBarcodeResult): void;
}

export function isAndroid() {
  return !!nativeApp;
}

// This represents the communication from Vue to the Android app
export default class Android implements NativeApp, AndroidActions {
  readonly type = NativeAppType.Android;
  readonly isMobile = true;

  private scanBarcodeCallback?: (result: ScanBarcodeResult) => void;

  register() {
    // Create a property on window that the android app can use to communicate with Vue.js
    (window as any).android = this;
  }

  // ----------------- Vue.js to android -----------------
  scanBarcode(): Promise<string | undefined> {
    return new Promise<string | undefined>((resolve, reject) => {
      // If there is a pending callback (not likely), cancel it since a new scan request has started
      this.scanBarcodeCallback?.({});

      // Register the callback before telling the native app to scan a barcode
      this.scanBarcodeCallback = result => {
        // Clear the callback after getting the result
        this.scanBarcodeCallback = undefined;
        resolve(result.barcode);
      };
      nativeApp?.scanBarcode();
    });
  }

  navigateToEditServer(): void {
    nativeApp?.navigateToEditServer();
  }

  // ----------------- android to Vue.js -----------------
  sendBarcodeResult(result: ScanBarcodeResult): void {
    this.scanBarcodeCallback?.(result);
  }
}
